import { render, staticRenderFns } from "./services-table.vue?vue&type=template&id=6291f7e2"
import script from "./services-table.vue?vue&type=script&lang=js"
export * from "./services-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports